/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight,
  faChevronLeft,
  faCalendarAlt,
  faShoppingBasket,
  faUsers,
  faShoppingBag,
  faShoppingCart,
} from '@fortawesome/free-solid-svg-icons';
import {
  Tab, Tabs, TabList, TabPanel,
} from 'react-tabs';
import moment from 'moment';
import Search from '../../components/Search';
import LoadingModal from '../../components/LoadingModal';
import logoImg from '../../assets/images/logo.png';
import { getPlantUpcomingOrders, getPlantPastHeldOrders, getCountofHnlOrders } from '../../store/modules/order/actions';
import {
  selectPlantPastHeldOrders, selectPlantUpcomingOrders, selectIsLoading, selectCount, selectIsLoadingCount,
} from '../../store/modules/order/selectors';

import './AdminPendingOrders.scss';

const AdminPendingOrders = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [query, setQuery] = useState(null);
  const dispatch = useDispatch();
  const upcoming = useSelector((state) => selectPlantUpcomingOrders(state));
  const pastHeld = useSelector((state) => selectPlantPastHeldOrders(state));
  const isLoading = useSelector((state) => selectIsLoading(state));
  const count = useSelector((state) => selectCount(state));
  const isLoadingCount = useSelector((state) => selectIsLoadingCount(state));

  useEffect(() => {
    if (tabIndex === 1) {
      dispatch(getPlantPastHeldOrders());
    } else {
      dispatch(getPlantUpcomingOrders());
    }
  }, [tabIndex]);

  useEffect(() => {
    dispatch(getCountofHnlOrders('plant'));
  }, []);

  const handleChange = (event) => {
    const { value } = event.target;
    setQuery(value);
  };

  const nextUpcomingPage = (page) => {
    dispatch(getPlantUpcomingOrders(page));
  };

  const previousUpcomingPage = (page) => {
    dispatch(getPlantUpcomingOrders(page));
  };

  const nextPastHeldPage = (page) => {
    dispatch(getPlantUpcomingOrders(page));
  };

  const previousPastHeldPage = (page) => {
    dispatch(getPlantUpcomingOrders(page));
  };

  return (
    <>
      <div className="admin-orders">
        <div className="row middle">
          <div className="col-12 col-md-3">
            <div className="summary-card warning mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faShoppingBasket} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Pending Orders
                </span>

                <span className="summary-card__value">
                  {count ? count?.pendingOrders : 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="summary-card green mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faShoppingBag} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Finished Orders
                </span>

                <span className="summary-card__value">
                  {count ? count?.finsihedOrders : 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="summary-card danger mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faUsers} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Rejected Orders
                </span>

                <span className="summary-card__value">
                  {count ? count?.rejectedOrders : 0}
                </span>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-3">
            <div className="summary-card primary mr-8">
              <div className="summary-card__left">
                <FontAwesomeIcon icon={faShoppingCart} className="summary-card__icon" />
              </div>
              <div className="summary-card__right">
                <span className="summary-card__label">
                  Total Orders
                </span>

                <span className="summary-card__value">
                  {count ? count?.totalOrders : 0}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="heading">
              <p className="heading__title">
                Order Details
              </p>
            </div>
          </div>
        </div>
        <Tabs
          defaultIndex={0}
          selectedIndex={tabIndex}
          onSelect={(index) => setTabIndex(index)}
        >
          <TabList className="row between tab-list">
            <Tab className="col-6 tab">
              <div className={`type-card ${tabIndex === 0 ? 'selected' : ''}`}>
                Upcoming Orders
              </div>
            </Tab>
            <Tab className="col-6 tab">
              <div className={`type-card ${tabIndex === 1 ? 'selected' : ''}`}>
                Past Held Orders
              </div>
            </Tab>
          </TabList>
          <TabPanel className="appointments-tab-panel">
            {/* <div className="row middle">
              <div className="col-12 col-md-12">
                <Search value={query} onChangeText={handleChange} onSubmit={search} />
              </div>
              <div className="col-12 col-md-2">
                <div className="buttons">
                  <button type="button" className="button green">
                    <FontAwesomeIcon icon={faFileExcel} className="button__icon" />
                    Export
                  </button>
                </div>
              </div>
            </div> */}
            <div className="row">
              {upcoming && upcoming.paginate && upcoming.paginate.length
                ? upcoming.paginate.map((order) => (
                  <div className="col-12 col-lg-12">
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          <img src={logoImg} alt="order" />
                        </div>
                        <div className="card__text">
                          <div>
                            <span className="card__title">
                              Plant Name :
                              {' '}
                            </span>
                            {order.Plant ? order.Plant.plantName : ''}
                          </div>
                          <div>
                            <span className="card__title">
                              Plant Code :
                              {' '}
                            </span>
                            {order.Plant ? order.Plant.plateCode : ''}
                          </div>
                          <div>
                            <span className="card__title">
                              Order Date :
                              {' '}
                            </span>
                            {moment(order.createdAt).format('DD/MM/YYYY')}
                          </div>
                          <div>
                            <span className="card__title">
                              Order Time :
                              {' '}
                            </span>
                            {moment(order.createdAt).format('hh:mm a')}
                          </div>
                        </div>
                      </div>
                      <div className="card__right">
                        <Link to={`/admin/orders/${order.id}`} className="card__button">View</Link>
                      </div>
                    </div>
                  </div>
                ))
                : (
                  null
                )}
              {!isLoading && !upcoming && (
              <div className="col-12 col-lg-12 d-flex-col middle">
                <div className="notFound">
                  <FontAwesomeIcon icon={faCalendarAlt} className="notFound__icon" />
                  <span className="notFound__text">No upcoming orders found</span>
                </div>
              </div>
              )}
            </div>
            {upcoming
              ? (
                <div className="row">
                  <div className="col-12 col-lg-12 d-flex-col middle">
                    <div className="pagination">
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!upcoming.Previous}
                        onClick={() => previousUpcomingPage(upcoming.Previous.page)}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} className="pagination__btn__icon" />
                      </button>
                      <span className="pagination__page">
                        {upcoming.Next
                          ? upcoming.Next.page - 1
                          : upcoming.Previous
                            ? upcoming.Previous.page + 1
                            : 1}
                      </span>
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!upcoming.Next}
                        onClick={() => nextUpcomingPage(upcoming.Next.page)}
                      >
                        <FontAwesomeIcon icon={faChevronRight} className="pagination__btn__icon" />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
          </TabPanel>
          <TabPanel className="appointments-tab-panel">
            {/* <div className="row middle">
              <div className="col-12 col-md-12">
                <Search value={query} onChangeText={handleChange} onSubmit={search} />
              </div>
              <div className="col-12 col-md-2">
                <div className="buttons">
                  <button type="button" className="button green">
                    <FontAwesomeIcon icon={faFileExcel} className="button__icon" />
                    Export
                  </button>
                </div>
              </div>
            </div> */}
            <div className="row">
              {pastHeld && pastHeld.paginate && pastHeld.paginate.length
                ? pastHeld.paginate.map((order) => (
                  <div className="col-12 col-lg-12">
                    <div className="card">
                      <div className="card__left">
                        <div className="card__avatar">
                          <img src={logoImg} alt="order" />
                        </div>
                        <div className="card__text">
                          <div className="row start">
                            <div className="col-12 col-lg-4">
                              <div>
                                <span className="card__title">
                                  Plant Name :
                                  {' '}
                                </span>
                                {order.Plant ? order.Plant.plantName : ''}
                              </div>
                              <div>
                                <span className="card__title">
                                  Plant Code :
                                  {' '}
                                </span>
                                {order.Plant ? order.Plant.plateCode : ''}
                              </div>
                              <div>
                                <span className="card__title">
                                  Order Date :
                                  {' '}
                                </span>
                                {moment(order.createdAt).format('DD/MM/YYYY')}
                              </div>
                              <div>
                                <span className="card__title">
                                  Order Time :
                                  {' '}
                                </span>
                                {moment(order.createdAt).format('hh:mm a')}
                              </div>
                            </div>
                            <div className="col-12 col-lg-4">
                              <div>
                                <span className="card__title">
                                  {order.status === 'finished' ? 'Finished Date' : 'Rejected Date'}
                                  {' '}
                                  :
                                  {' '}
                                </span>
                                {moment(order.finishedDate).format('DD/MM/YYYY')}
                              </div>
                              <div>
                                <span className="card__title">
                                  {order.status === 'finished' ? 'Finished Time' : 'Rejected Time'}
                                  {' '}
                                  :
                                  {' '}
                                </span>
                                {moment(order.finishedDate).format('hh:mm a')}
                              </div>
                              <div>
                                <span className="card__title">
                                  Total Time Taken :
                                  {' '}
                                </span>
                                {moment(order.finishedDate).diff(order.createdAt, 'days')}
                                {' '}
                                days
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card__right">
                        <div
                          className={`card__text--${order.status === 'finished' ? 'primary'
                            : order.status === 'rejected' ? 'danger' : ''}`}
                        >
                          <span
                            className="card__title"
                          >
                            Status :
                            {' '}
                          </span>
                          {order.status === 'finished' ? 'approved' : order.status}
                        </div>
                        <Link
                          to={`/admin/orders/${order.id}`}
                          className="card__button"
                        >
                          View
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
                : (
                  null
                )}
              {!isLoading && !pastHeld && (
              <div className="col-12 col-lg-12 d-flex-col middle">
                <div className="notFound">
                  <FontAwesomeIcon icon={faCalendarAlt} className="notFound__icon" />
                  <span className="notFound__text">No past held orders found</span>
                </div>
              </div>
              )}
            </div>
            {pastHeld
              ? (
                <div className="row">
                  <div className="col-12 col-lg-12 d-flex-col middle">
                    <div className="pagination">
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Previous}
                        onClick={() => previousPastHeldPage(pastHeld.Previous.page)}
                      >
                        <FontAwesomeIcon icon={faChevronLeft} className="pagination__btn__icon" />
                      </button>
                      <span className="pagination__page">
                        {pastHeld.Next
                          ? pastHeld.Next.page - 1
                          : pastHeld.Previous
                            ? pastHeld.Previous.page + 1
                            : 1}
                      </span>
                      <button
                        type="button"
                        className="pagination__btn"
                        disabled={!pastHeld.Next}
                        onClick={() => nextPastHeldPage(pastHeld.Next.page)}
                      >
                        <FontAwesomeIcon icon={faChevronRight} className="pagination__btn__icon" />
                      </button>
                    </div>
                  </div>
                </div>
              ) : null}
          </TabPanel>
        </Tabs>
      </div>
      <LoadingModal show={isLoading || isLoadingCount} />
    </>
  );
};

export default AdminPendingOrders;
